import { ReactNode, useCallback, useState } from "react"
import { emptyState, FrequenciesFilterContext } from "."
import { FrequenciesFilterField, FrequenciesFilterState, SetFilterProps } from "../lib/types"

type FrequenciesFilterProvider = {
  children: ReactNode
}

export default function FrequenciesFilterProvider({ children }: FrequenciesFilterProvider) {
  const [filter, setFilterState] = useState<FrequenciesFilterState>(emptyState)
  
  const setFilter = useCallback((filter: SetFilterProps) => {
    const stringFilters = [FrequenciesFilterField.TSID, FrequenciesFilterField.frequency, FrequenciesFilterField.modulation]

    if(stringFilters.includes(filter.fieldName) || filter.fieldName === FrequenciesFilterField.signalHealth){
      return setFilterState(currentState => {
        return { ...currentState, [filter.fieldName]: filter.value }
      })
    }

    if(filter.fieldName === FrequenciesFilterField.signalLevel) {
      return setFilterState(currentState => {
        return {...currentState, [FrequenciesFilterField.signalLevel]: {
          value: filter.value,
          filter: filter.filter,
        }}
      })
    }
  }, [])

  return (
    <FrequenciesFilterContext.Provider value={{ filter, setFilter }}>
      {children}
    </FrequenciesFilterContext.Provider>
  )
}
